import { render, staticRenderFns } from "./organization-control-history.vue?vue&type=template&id=3e370fc0&"
import script from "./organization-control-history.vue?vue&type=script&lang=js&"
export * from "./organization-control-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports